import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('产品特色-Trinka高级英语学术和技术写作工具');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka是旨在使学术和技术英语写作写作变得轻松自如的工具，能增强了您作品的语调，风格和结构，达到出版要求。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '高级语法检查，高级拼写检查，句子更正，句子结构检查工具，科学语调，格式指南' });
    this.metaTagService.updateTag({ property: 'og:title', content: '产品特色-Trinka高级英语学术和技术写作工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka是旨在使学术和技术英语写作写作变得轻松自如的工具，能增强了您作品的语调，风格和结构，达到出版要求。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/features' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/tw/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features' });
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/typod.js', function () { });
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
  }

}
